import Api from '../../shared/services/api'

const baseUrl = "ClientPrices";
export default {

  get(entity, options) {
    const qParams = new URLSearchParams(options);
    return Api().get(`${baseUrl}/list/${entity.id}` + `?${qParams.toString()}`);
  },
  gettoadd(entity) {
    return Api().get(`${baseUrl}/list/${entity.id}` + `?ItemsPerPage=-1`);
  },
  gettoaddphoneNumber(phoneNumber) {
    return Api().get(`${baseUrl}/getByphoneNumber/${phoneNumber}` + `?ItemsPerPage=-1`);
  },
  getClientLastShipment(clientId) {
    return Api().get(`${baseUrl}/getClientLastShipment/${clientId}`);
  },
  query(options) {
    const qParams = new URLSearchParams(options);
    return Api().get(`${baseUrl}?${qParams.toString()}`);
  },
  edit(entity) {
    if (entity.id) return Api().put(`${baseUrl}/${entity.id}`, entity.clientData);
    return this.add(entity);
  },
  add(entity) {
    return Api().post(`${baseUrl}/${entity.clientId}`, entity.clientData);
  },
  addSingle(entity) {
    return Api().post(`${baseUrl}/addSingle/${entity.clientId}`, entity.clientData);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  }
}
